<template>
  <v-container id="staff-report" fluid tag="section">
    <filter-form :filterForm="filterForm" :stores="stores"/>
    <personal-revenue :staff="staff" :reportStaff="reportStaff" :duration="filterForm.dateRange.duration"/>
    <personal-chart v-if="dataChart.labels.length" :dataChart="dataChart"/>

<!--    <personal-call v-if="dataChart.labels.length" :dataChart="dataChart"/>-->
    <personal-call v-if="dataChart.labels.length" :dataChart="dataCallChart"/>

    <PersonalStatusReport
      v-if="contactStatusList.length"
      :typeHeaderContactStatus="typeHeaderContactStatus"
      :contactStatusList="contactStatusList"
      :contactStatusTotal="contactStatusTotal"
    />
    <PersonalContactSource
      v-if="!_.isEmpty(dataReport)"
      :dataReport="dataReport"
    />
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm.vue'
  import PersonalRevenue from './components/PersonalRevenue.vue'
  import PersonalChart from './components/PersonalChart.vue'
  import PersonalStatusReport from './components/PersonalStatusReport'
  import PersonalContactSource from './components/PersonalContactSource'
  import PersonalCall from "./components/PersonalCall";

  import RepositoryFactory from "@/repositories/RepositoryFactory";
  import * as moment from 'moment'

  const UserRepository = RepositoryFactory.get('user');
  const ReportRepository = RepositoryFactory.get('report');
export default {
  components: {PersonalCall, FilterForm, PersonalRevenue, PersonalChart, PersonalStatusReport, PersonalContactSource },
  data () {
    return {
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          duration: 'today',
        },
        shift: [],
        storeId: 0,
        userId: ''
      },
      staff: {},
      reportStaff: {},
      reportStaffChart: [],
      reportStaffCallChart: [],
      reportByContact: {},
      dataChart: {
        labels: [],
        series: [],
        successTurnOver: [],
        initTurnOver: [],
        userInitLatchRatio: [],
      },
      dataCallChart: {
        labels: [],
        series: [],
        numberOfCallSuccess: [],
        totalOfCallSuccess: [],
        avgOfCall: [],
      },
      typeHeaderContactStatus: [],
      contactStatusList: [],
      contactStatusTotal: [],
      showStatusReport: false,
      dataReport: {},
      stores: [
        {
          label: 'Tất cả',
          value: 0
        },
        {
          label: 'Kho C',
          value: 1
        },
        {
          label: 'Kho T',
          value: 2
        },
        // {
        //   label: 'Kho G',
        //   value: 3
        // }
      ],
      watchModule: ''
    }
  },
  created() {
    Bus.$on('staff-filter-list-fe', (filterForm, staff) => {
      this.filterForm = filterForm
      this.getReportStaff()
      this.getReportStaffChart()
      this.getReportStaffCallChart()
      this.showStatusReport = true
      this.staff = staff
    })

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          dateRange: {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            duration: 'today',
          },
          shift: [],
          storeId: 0,
          userId: ''
        }
        this.reportStaff = {}
        this.reportStaffChart = []
        this.reportStaffCallChart = []
        this.reportByContact = {}
        this.dataChart = {
          labels: [],
          series: [],
          successTurnOver: [],
          initTurnOver: [],
          userInitLatchRatio: []
        }
        this.dataCallChart = {
          labels: [],
          series: [],
          numberOfCallSuccess: [],
          totalOfCallSuccess: [],
          avgOfCall: []
        }
        this.typeHeaderContactStatus = []
        this.contactStatusList = []
        this.contactStatusTotal = []
        this.dataReport = {}
        this.showStatusReport = false
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy () {
    Bus.$off('staff-filter-list-fe')
    this.watchModule()
  },
  methods: {
    async getReportStaff() {
      const loader = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        userId: this.filterForm.userId,
        duration: this.filterForm.dateRange.duration,
        shift: this.filterForm.shift,
        storeId: this.filterForm.storeId,
        schoolLevelId:this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const response = await ReportRepository.personalReportFe(params)

      loader.hide()
      if (response.success) {
        this.reportStaff = _.get(response, 'data', {})
      }
    },
    async getReportStaffChart() {
      const loader = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        userId: this.filterForm.userId,
        duration: this.filterForm.dateRange.duration,
        shift: this.filterForm.shift,
        storeId: this.filterForm.storeId,
        schoolLevelId:this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const response = await ReportRepository.personalChart(params)
      loader.hide()
      if (response.success) {
        this.reportStaffChart = _.get(response, 'data', [])
        this.getMultiLineData();
        await this.getDataStatusReport()
        await this.getDataContactSource()
      }
    },
    async getReportStaffCallChart() {
      const loader = this.$loading.show()
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        userId: this.filterForm.userId,
        duration: this.filterForm.dateRange.duration,
        shift: this.filterForm.shift,
        storeId: this.filterForm.storeId,
        schoolLevelId:this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      };
      const response = await ReportRepository.personalCallChart(params)
      loader.hide()
      if (response.success) {
        this.reportStaffCallChart = _.get(response, 'data', [])
        this.getMultiLineDataCall();
      } else {
        this.reportStaffCallChart = []
        this.dataCallChart = {
          labels: [],
          series: [],
          numberOfCallSuccess: [],
          totalOfCallSuccess: [],
          avgOfCall: [],
        }
      }
      // loader.hide()
      //   this.reportStaffCallChart = _.get(this.dataReportByCall, 'data', [])
      //   this.getMultiLineDataCall();
    },
    getMultiLineData() {
      const getDataLabel = this.reportStaffChart.map(v => Object.keys(v)[0])
      this.dataChart.labels = getDataLabel.map(c => {
        return c;
      })
      const data = this.reportStaffChart.map(data => data[Object.keys(data)[0]])
      this.dataChart.successTurnOver = data.map(a => parseInt(a.successTurnOver, 10) || 0)
      // this.dataChart.initLatchRatio = data.map(c => parseInt(c.initLatchRatio, 10) || 0)
      this.dataChart.initTurnOver = data.map(b => parseInt(b.initTurnOver, 10) || 0)

      this.dataChart.series = [
        this.dataChart.successTurnOver.map(d => ({ meta: 'Doanh thu thành công :', value: d })),
        this.dataChart.initTurnOver.map(d => ({ meta: 'Doanh thu khởi tạo :', value: d })),
        // this.dataChart.initLatchRatio.map(d => ({ meta: 'Tỉ lệ chốt :', value: d })),
      ]
      Bus.$emit('staff-data-chart')
    },
    getMultiLineDataCall() {
      const getDataLabel = this.reportStaffCallChart.map(v => Object.keys(v)[0])
      this.dataCallChart.labels = getDataLabel.map(c => {
        return c;
      })
      const data = this.reportStaffCallChart.map(data => data[Object.keys(data)[0]])
      this.dataCallChart.numberOfCallSuccess = data.map(a => parseInt(a.numberOfCallSuccess, 10) || 0)
      this.dataCallChart.totalOfCallSuccess = data.map(c => parseInt(c.totalOfCallSuccess, 10)/10 || 0)
      this.dataCallChart.avgOfCall = data.map(b => parseInt(b.avgOfCall, 10) || 0)

      this.dataCallChart.series = [
        this.dataCallChart.numberOfCallSuccess.map(d => ({ meta: 'Số cuộc gọi :', value: d })),
        this.dataCallChart.totalOfCallSuccess.map(d => ({ meta: 'Số phút gọi :', value: d })),
        this.dataCallChart.avgOfCall.map(d => ({ meta: 'TB gọi :', value: d })),
      ]
      Bus.$emit('staff-data-call-chart')
    },

    async getDataStatusReport() {
      const loading = this.$loading.show();
      const response = await ReportRepository.personalByContactStatus({
        userId: this.filterForm.userId,
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        shift: this.filterForm.shift,
        schoolLevelId:this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      loading.hide();
      if (response.success) {
        const typeHeaderContactStatus = [];
        const contactStatusList = [];
        const contactStatusTotal = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          if(contactStatus.type !== 'T0' && contactStatus.type !== 'C0'){
            typeHeaderContactStatus.push({
              name: contactStatus.type,
              colspan: _.get(contactStatus, 'data', []).length || 1
            });

            let percentageTotal = 0
            let countItemsTotal = 0

            _.get(contactStatus, 'data', []).forEach(data => {
              if(contactStatus.type !== 'T0' && contactStatus.type !== 'C0') {
                contactStatusList.push({
                  type: contactStatus.type,
                  id: _.get(data, 'id', 0),
                  countItems: _.get(data, 'countItems', 0),
                  name: _.get(data, 'name', 0),
                  percentage: _.get(data, 'percentage', 0)
                });
                percentageTotal += +data.percentage
                countItemsTotal += +data.countItems
              }
            });
            contactStatusTotal.push({
              type: contactStatus.type,
              percentage: percentageTotal,
              countItems: countItemsTotal
            })
          }
        });

        this.typeHeaderContactStatus = typeHeaderContactStatus;
        this.contactStatusList = contactStatusList;
        this.contactStatusTotal = contactStatusTotal
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },

    async getDataContactSource() {
      const loading = this.$loading.show();
      const response = await ReportRepository.reportByContact({
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        userId: this.filterForm.userId,
        duration: this.filterForm.dateRange.duration,
        shift: this.filterForm.shift,
        storeId: this.filterForm.storeId,
        schoolLevelId:this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      loading.hide();
      if (response.success) {
        this.dataReport = _.get(response, 'data')
      }
    }

  }
}
</script>
